
import React from 'react';

interface AnimateVeoAudioIconProps extends React.SVGProps<SVGSVGElement> {}

const AnimateVeoAudioIcon: React.FC<AnimateVeoAudioIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 9V4.5M9 9c0-1.381.71-2.572 1.757-3.222M9 9v6.75M15 9V4.5M15 9c0-1.381-.71-2.572-1.757-3.222M15 9v6.75M5.25 19.343A1.5 1.5 0 0 1 7.5 18v-6a1.5 1.5 0 0 1 1.5-1.5h6a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-2.25 1.343L12 18.75l-2.25 1.093A1.5 1.5 0 0 1 7.5 19.343Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 7.5C5.25 6.034 6.034 5.25 7.5 5.25c0-1.518.795-2.25 2.25-2.25S12 3.732 12 5.25c1.455 0 2.25.732 2.25 2.25 1.466 0 2.25.784 2.25 2.25v3.75" />
     {/* Simplified representation of video with audio */}
  </svg>
);

export default AnimateVeoAudioIcon;
